import { defineStore } from 'pinia';

/** The signed-in staff user the layout confirmed, so pages can tell their own saves from others'. */
const useStaffUserStore = defineStore('staffUser', {
    state: () => ({ id: null as string | null }),
    getters: {
        getId: (state): string | null => {
            return state.id;
        },
    },
    actions: {
        set(id: string) {
            this.id = id;
        },
    },
});

export default useStaffUserStore;
